// NOTE: `DOMException` is a browser-only global. Hermes — the JS engine behind
// both iOS and Android — does not define it, so `new DOMException(...)` and
// even a bare `error instanceof DOMException` throw a ReferenceError of their
// own on mobile (NSAI-4663). This package must stay isomorphic so Vite and
// Metro can both bundle it (see this package's CLAUDE.md), which is why the
// two shapes are wrapped here instead of being reached for directly.
const ABORT_ERROR_NAME = "AbortError";

// NOTE: Where `DOMException` exists the real thing is still constructed, so the
// web app's existing `error instanceof DOMException` checks keep matching —
// `web/src/lib/query-client.ts` (global mutation error toast),
// `web/src/api/vstr-audio/useUploadVstrAudioFile.ts` and
// `web/src/api/presentation-theme/useGeneratePresentationThemeFromFile.ts`.
// Dropping that branch would silently turn a user cancellation into an error
// toast on web, so it must stay until those three move to `isAbortError`.
export const createAbortError = (message: string): Error => {
  if (typeof DOMException !== "undefined") {
    return new DOMException(message, ABORT_ERROR_NAME);
  }

  const error = new Error(message);
  error.name = ABORT_ERROR_NAME;

  return error;
};

// NOTE: The cross-platform way to ask "was this cancelled?". Matches on `name`
// rather than on a constructor, so it holds for both shapes above. Callers that
// also drive axios need to keep their own `isCancel` / `CanceledError` branch —
// an aborted axios request is named "CanceledError", not "AbortError".
export const isAbortError = (error: unknown): boolean =>
  error instanceof Error && error.name === ABORT_ERROR_NAME;
